import { Suspense } from 'react';

import { IwocaLogo } from '@iwoca/orion';
import { Route, Switch } from 'react-router-dom';

import { ApplicantCallPage } from './ApplicantCallStep/ApplicantCallPage/ApplicantCallPage';
import { BankDetailsForm } from './BankDetailsStep/BankDetailsForm/BankDetailsForm';
import { CommissionConsentForm } from './CommissionConsentStep/CommissionConsentForm/CommissionConsentForm';
import { SignCreditAgreement } from './CreditAgreementStep/SignCreditAgreement/SignCreditAgreement';
import { DebitCardForm } from './DebitCardStep/DebitCardForm/DebitCardForm';
import { FundingRequirementsLoanSummary } from './FundingRequirementsLoanSummary/FundingRequirementsLoanSummary';
import { IdCheck } from './IdCheckStep/IdCheck';
import { InnerLayoutSkeleton } from './InnerLayout/InnerLayoutSkeleton';
import { MobileFundingRequirementsLoanSummary } from './MobileFundingRequirementsLoanSummary/MobileFundingRequirementsLoanSummary';
import { SignPersonalGuarantee } from './PersonalGuaranteeStep/SignPersonalGuarantee/SignPersonalGuarantee';
import { RequirementsList } from './RequirementsList/RequirementsList';
import { ShareholdersPage } from './ShareholdersStep/ShareholdersPage/ShareholdersPage';
import { LinkOpenBankingPage } from './UploadBankEvidenceStep/LinkOpenBankingPage/LinkOpenBankingPage';
import { useMediaQuery } from '../../../../customHooks/useMediaQuery';
import { ErrorBoundary } from '../../../../errorBoundary/ErrorBoundary';
import FallbackErrorModal from '../../../modals/fallbackErrorModal/FallbackErrorModal';
import { TrustPilot } from '../../../TrustPilot/TrustPilot';
import { NeedHelpSection } from '../ApprovedView/NeedHelpSection/NeedHelpSection';
import { FundingProgressIndicator } from '../FundingProgressIndicator/FundingProgressIndicator';

export const FundingRequirements = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)');

    return (
        <div className="flex flex-col bg-structure-100 min-m:flex-row">
            {isDesktop && <FundingRequirementsLoanSummary />}
            <div className="grow p-xl">
                <FundingProgressIndicator step={4} />
                {!isDesktop && <MobileFundingRequirementsLoanSummary />}

                <ErrorBoundary
                    fallback={(error) => <FallbackErrorModal error={error} />}
                >
                    <Suspense fallback={<InnerLayoutSkeleton />}>
                        <Switch>
                            <Route exact path="/funding-requirements/">
                                <RequirementsList />
                            </Route>
                            <Route path="/funding-requirements/debit-card">
                                <DebitCardForm />
                            </Route>
                            <Route path="/funding-requirements/bank-details">
                                <BankDetailsForm />
                            </Route>
                            <Route path="/funding-requirements/sign-personal-guarantee">
                                <SignPersonalGuarantee />
                            </Route>
                            <Route path="/funding-requirements/sign-credit-agreement">
                                <SignCreditAgreement />
                            </Route>
                            <Route path="/funding-requirements/commission-consent">
                                <CommissionConsentForm />
                            </Route>
                            <Route path="/funding-requirements/applicant-call">
                                <ApplicantCallPage />
                            </Route>
                            <Route path="/funding-requirements/id-check">
                                <IdCheck />
                            </Route>
                            <Route path="/funding-requirements/shareholders">
                                <ShareholdersPage />
                            </Route>
                            <Route path="/funding-requirements/link-open-banking">
                                <LinkOpenBankingPage />
                            </Route>
                        </Switch>
                    </Suspense>
                </ErrorBoundary>

                {!isDesktop && (
                    <>
                        <div className="mt-2xl">
                            <NeedHelpSection variant="funding-mobile" />
                        </div>
                        <div className="mt-2xl flex flex-col items-center pb-m">
                            <IwocaLogo
                                className="mb-xl w-[100px]"
                                color="red"
                            />
                            <TrustPilot />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
